<template>
	<div id="footer">
		<p class="footermap">地址：中国·四川·成都市高新区吉庆三路333号蜀都中心二期一号楼一单元1502号</p>
		<p class="p">Copyright 2002 All Rights Reserved</p>
		<p class="p">蜀ICP备11005312号</p>
	</div>
</template>

<script>
	export default {
		name: 'footerbox',  
		data() {
			return {
				
			}
		},
		methods: {
			
		},
		mounted() {
	
	
		},
	
	}
</script>

<style lang="scss" scoped>
	#footer{
		background: #484849;
		padding:2.5rem 1.3rem;
		.footermap{
			font-size: 1.3rem;
			color: rgba(255,255,255,.6);
			margin-bottom: 0.6rem;
			padding: 0 3rem;
		}
		.p{
			font-size: 1.3rem;
			color: rgba(255,255,255,.2);
		}
	}
</style>
